import { Form } from "@canvas/vuejsonschemaform";

import {
  ATypography as ATypographyComponent,
  ACheckbox as ACheckboxComponent,
} from "@canvas/componentlibrary";
import CheckBoxGroup from "./CheckBoxGroup.vue";
import Vue from "vue";


const ATypography = ATypographyComponent as any;
const ACheckbox = ACheckboxComponent as any;
const CheckboxGroup = CheckBoxGroup as any;

export function renderObjectAsAddressForm(
  this: Form,
  h: any,
  schema: any,
  formdata: any,
  required: boolean
) {
  const { model, status, propname } = formdata;
  const update = (siteAddress: {
    address: { name: string; display_name: string };
    pincode: string;
    door_no: string;
    landmark: string;
  }) => {
    model[propname] = Object.assign(
      JSON.parse(JSON.stringify(model[propname])),
      siteAddress
    );
    status[propname] = "success";
  };
  const updateCheckBox = (event: any) => {
    if (event.target.checked) {
      model[propname].checkBox = true;
      status[propname] = "success";
      model[propname].pincode = "success";
    } else {
      model[propname].checkBox = false;
      model[propname].pincode = "";
    }
  };

  return (
    <div>
      <div style={{ display: "flex", "justify-content": "space-between" }}>
        <ATypography variant="subtitlelarge">{schema.title}</ATypography>
        {schema.showCheckBox && (
          <ACheckbox onChange={updateCheckBox}>
            {schema.checkBoxTitle}
          </ACheckbox>
        )}
      </div>
      {!model[propname].checkBox && (
        <a-form-item
          label={schema.title}
          required={required}
          style={{ "margin-bottom": "20px" }}
        >
          <address-form
            disabled={{
              address: schema.properties.address.readOnly,
              pincode: schema.properties.pincode.readOnly,
              door_no: schema.properties.door_no.readOnly,
              landmark: schema.properties.landmark.readOnly
            }}
            siteAddress={model[propname]}
            statesUrl={schema.states_url}
            placesUrl={schema.places_url}
            coordinatesUrl={schema.coordinates_url}
            onChange={update}
            getResource={this.getResource}
            status={status}
            propname={propname}
          />
        </a-form-item>
      )}
    </div>
  );
}

export function arrayRenderComposite(
  this: Form,
  h: any,
  schema: any,
  formdata: any,
  required: boolean,
  renderer: (path: string) => void,
  currentpath: string
) {
  let otherInputValue: String = "";
  let othersFlag: Boolean = false;
  const update = (values: any, othersFlag: boolean) => {
    if (!values.includes("others") && !othersFlag) {
      if (model.hasOwnProperty(propname + "_others")) {
        // Remove the key from the model object
        Vue.delete(model, propname + "_others");
      }
    }
    model[propname] = [values];
    if (schema.type === 'string') {
      model[propname] = values;
    }
    status[propname] = "success";
  };
  const updateInput = (inputValue: string) => {
    model[propname + "_others"] = inputValue;
    status[propname] = "success";
  };
  const { model, status, propname } = formdata;
  let displayNames = Object.keys(schema.items.displayNames);
  let options = [];
  if (schema.items.displayNames) {
    for (let i = 0; i < schema.items.enum.length; i++) {
      let option = schema.items.enum[i];
      if (displayNames.includes(option)) {
        options.push({
          name: option,
          display_name: schema.items.displayNames[option],
        });
      }
    }
  }
  if (model[propname].includes("others")) {
    otherInputValue = model[propname + "_others"];
    othersFlag = true;
  }

  return (
    <CheckboxGroup
      value={schema.type === 'string' ? [model[propname]] : model[propname]}
      options={options}
      validateStatus={status[propname]}
      layout={schema.layout}
      required={required}
      title={schema.title}
      onChange={update}
      onInput={updateInput}
      othersFlag={othersFlag}
      otherInputValue={otherInputValue}
    ></CheckboxGroup>
  );
}